/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Bot_Or_AutoInputs */

const tr_landing_pricerules_mock_bot_or_auto = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Or_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`veya tam otomatik`)
};

const en_landing_pricerules_mock_bot_or_auto = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Or_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or fully automatic`)
};

const de_landing_pricerules_mock_bot_or_auto = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Or_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oder vollautomatisch`)
};

const ru_landing_pricerules_mock_bot_or_auto = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Or_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`или полностью автоматически`)
};

/**
* | output |
* | --- |
* | "or fully automatic" |
*
* @param {Landing_Pricerules_Mock_Bot_Or_AutoInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_bot_or_auto = /** @type {((inputs?: Landing_Pricerules_Mock_Bot_Or_AutoInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Bot_Or_AutoInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_bot_or_auto(inputs)
	if (locale === "de") return de_landing_pricerules_mock_bot_or_auto(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_bot_or_auto(inputs)
	return tr_landing_pricerules_mock_bot_or_auto(inputs)
});